import { Link } from 'react-router-dom';
import './Footer.css';
import { useDevice } from '../hooks';
import { getLinkWithParams } from '../utils';

export function Footer() {
   const { isMobile } = useDevice();
   return (
      <footer className="">
         <div className="footer-container">
            <div className="footer-content flex flex-col gap-3">
               <div className="flex items-center gap-3 justify-between">
                  <div className="flex items-center  flex-1">
                     <img
                        src="/assets/images/golfn-logo.png"
                        width={100}
                        alt=""
                     />
                  </div>
                  <div className={`flex-2 flex   gap-2 wrap ${isMobile ? 'flex-col justify-end items-end' : 'items-center justify-between'}`}>
                     <div className={`flex flex-col gap-2 ${isMobile ? 'flex-col items-end' : ''}`}>
                        {/* <Link to="/account">My Account</Link> */}

                        <Link
                           to={getLinkWithParams('/referral-center')}
                           className="large">
                           Referral Center
                        </Link>
                        <Link
                           // to="/sweepstakes"
                           to={getLinkWithParams('/sweepstakes')}
                           className="large">
                           Sweepstakes
                        </Link>
                        <Link
                           to={getLinkWithParams('/my-entries')}
                           className="large">
                           My Entries
                        </Link>
                     </div>
                     <div>
                        <Link
                           to="https://golfn.com"
                           target="_blank"
                           className="large green">
                           Visit GolfN
                        </Link>
                     </div>
                  </div>
               </div>
               <div className="flex items-center justify-between">
                  <span className="gray">{new Date().getFullYear()} GolfN. All rights reserved.</span>

                  <div className="flex gap-2">
                     <Link
                        to="https://app.termly.io/policy-viewer/policy.html?policyUUID=0123e5c2-b91e-4e83-9758-33f23af400eb"
                        target="_blank"
                        className="gray">
                        Privacy Policy
                     </Link>
                     <Link
                        to="https://app.termly.io/policy-viewer/policy.html?policyUUID=9ac4a65e-c88a-460e-b45f-4f79166cb93b"
                        target="_blank"
                        className="gray">
                        Terms of Service
                     </Link>
                  </div>
               </div>
            </div>
         </div>
      </footer>
   );
}
